import React from 'react';
import appInsights from './appInsights';
import ErrorPage from '../src/components/Error/ErrorPage';
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { hasError: false };
  }

  static getDerivedStateFromError() {
    return { hasError: true };
  }

  componentDidCatch(error, errorInfo) {
    appInsights.trackException({
      exception: error,
      properties: errorInfo,
    });
  }

  render() {
    if (this.state.hasError) {
      return (
        <ErrorPage/>
      );
    }

    return this.props.children;
  }
}

export default ErrorBoundary;
